function NotFound() {
  return <div>NotFound / Unauthorized</div>;
}

export default NotFound;
